<section class="funcionalidades-screen">
  <header class="funcionalidades-screen__header">
    <h1 class="page-main-title">Cadastro e Parametrização</h1>
    <p class="funcionalidades-screen__subtitulo">
      Escolha o que você quer administrar no perfil de investimento.
    </p>
  </header>

  <div class="funcionalidades-grid">
    @for (item of funcionalidades; track item.rota) {
      <button
        type="button"
        class="funcionalidade-card"
        [class.funcionalidade-card--disabled]="item.desabilitado"
        [disabled]="item.desabilitado"
        [attr.aria-disabled]="item.desabilitado"
        (click)="navegar(item)"
      >
        <span class="funcionalidade-card__topo">
          <!-- O ícone é decorativo: o título ao lado já nomeia a funcionalidade. -->
          <span class="funcionalidade-card__icone" aria-hidden="true">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              @switch (item.icone) {@case ('planos') {
                  <rect x="4" y="4" width="16" height="16" rx="2" />
                  <path d="M8 9h8M8 13h8M8 17h5" />
                }
              }
            </svg>
          </span>

          @if (item.desabilitado) {
            <span class="funcionalidade-card__tag" data-testid="funcionalidade-tag">Em breve</span>
          } @else {
            <span class="funcionalidade-card__seta" aria-hidden="true">&#8594;</span>
          }
        </span>

        <span class="funcionalidade-title">{{ item.titulo }}</span>
        <span class="funcionalidade-card__descricao">{{ item.descricao }}</span>
      </button>
    }
  </div>
</section>
